/**
 * 股票信息
 */

export default {
  /**
   * 根据股票的新闻或者公告研报
   * @param  
   * @param type  类别 1 新闻 2 公告
   * @param condition
   */
  async getStockNewsOrNotice(code:string, market:string, type:number, condition:string, pageNumber: number, pageSize: number):Promise<null|{
    condition:string,
    news: Array<object>
  }>{

    let typestring = 'securityNews' //新闻
    if(type == 2){
      typestring = 'securityNotice' //公告
    }
    else if(type == 3){
      typestring = 'securityReport' //研报
    }

    return $.ajax({
      url: 'https://emdcnewsapp.eastmoney.com/infoService?callback=?',
      type: 'GET',
      dataType: 'jsonp',
      data: {
        data: JSON.stringify({
          "args": {
            "securityCode": code, 
            "market": market, 
            "fields": "recordId,infoCode,title,showDateTime,publishDate,updateTime,total,code", 
            "condition": condition, 
            "pageNumber": pageNumber, 
            "pageSize": pageSize
          }, 
          "method": typestring, 
          "appKey": "68fuOWXP9gf46fQf", 
          "client": "wap",
          "clientVersion": null, 
          "clientType": null, 
          "randomCode": "7cb4f0dddc4b4211b9289f94d4f61737", 
          "reserve": null, 
          "timestamp": "15487708124631376"
        })
      }
    }).then(v=>{
      if(v.code == 0){
        return {
          condition: v.data.condition,
          news: v.data.items
        }        
      }
      else{
        return null
      }
    })
  }
}